import Enum from './enum'

/**
 * 料金種別
 */
class PriceType extends Enum {
    static USERS_20 = 1;
    static USERS_50 = 2;
    static USERS_100 = 3;
    static USERS_UNLIMITED = 4;

    static values() {
        return {
            [this.USERS_20]: '20ユーザプラン (9,800 円/月)',
            [this.USERS_50]: '50ユーザプラン (12,800 円/月)',
            [this.USERS_100]: '100ユーザプラン (15,800 円/月)',
            [this.USERS_UNLIMITED]: '無制限プラン (19,800 円/月)',
        }
    }

    /**
     * 料金を取得
     * @param {number} priceType 料金種別
     * @returns {number} 料金（円）
     */
    static amount(priceType) {
        const amounts = {
            [this.USERS_20]: 9800,
            [this.USERS_50]: 12800,
            [this.USERS_100]: 15800,
            [this.USERS_UNLIMITED]: 19800,

        };
        return amounts[priceType] || 0;
    }
}

export default PriceType;